import React, { Suspense } from 'react';
import getPopoverStyles from './popoverStyles.js';

const lazyWithPreload = (factory) => {
  const Component = React.lazy(factory);
  Component.preload = factory;
  return Component;
};
const ToolTip = lazyWithPreload(() => import('react-portal-tooltip'));
const Popover = ({
  children,
  parent,
  active = false,
  position = "top",
  langDir
}) => {
  const popoverStyles = getPopoverStyles(langDir);
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React.createElement(
    ToolTip,
    {
      parent,
      active,
      position,
      arrow: "center",
      style: popoverStyles
    },
    children
  ));
};

export { Popover as default };
//# sourceMappingURL=Popover.js.map
